<template>
  <div>
    <div class="row">
      <div class="col-12 pl-0">
        <div class="p-3">
          <form @submit.prevent="updateUser">
            <div class="row align-items-center">
              <div class="col-12">
                <div class="row justify-content-between">
                  <div class="col-auto">
                    <h5 class="e-text-red">
                      {{
                        auditorData
                          ? [
                            auditorData.honorifics,
                            auditorData.first_name,
                            auditorData.middle_name,
                            auditorData.last_name,
                            auditorData.suffix
                          ].filter(Boolean).join(' ')
                          : ''
                      }}
                    </h5>
                  </div>
                  <div class="col-auto" v-if="isAllowed('audit-team.auditors.edit') && auditorData.is_designated_person === 1">
                    <button class="e-btn e-btn-outlined-red e-text-red e-text-white-hover mr-1" type="button" v-if="toEdit" @click="cancelEdit">
                      <font-awesome-icon icon="ban" class="e-text-red"/>
                      Cancel
                    </button>
                    <button class="e-btn e-btn-outlined-orange e-text-orange e-text-white-hover" v-else type="button" @click="editAuditor">
                      <font-awesome-icon icon="pen" class="e-text-orange"/>
                      Edit Auditor
                    </button>
                    <button class="e-btn e-btn-green e-text-white ml-1" type="submit" v-if="toEdit">
                      <font-awesome-icon icon="save"/>
                      Save
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-lg-10">
                <div class="row align-items-center no-gutters my-1">
                  <div class="col-12">
                    <h6 class="mb-0 font-weight-bold e-text-red">DP Information</h6>
                  </div>
                </div>
                  <template v-if="auditorData && auditorData.is_designated_person === 1">
                    <div class="row align-items-center no-gutters mb-1">
                      <div class="col-lg-2">
                        <label class="font-weight-bolder mb-0">(D.P.) Branch Office:</label>
                      </div>
                      <div class="col-lg-10">
                        {{ (auditorData && auditorData?.dp_branch_office) ? auditorData?.dp_branch_office?.name : '' }}
                      </div>
                    </div>
                    <div class="row align-items-center no-gutters mb-1">
                      <div class="col-lg-2">
                        <label class="font-weight-bolder mb-0">(D.P.) Audit Types:</label>
                      </div>
                      <div class="col-lg-10 text-uppercase">
                        {{ (auditorData && auditorData?.audit_types) ? auditorData?.audit_types.join(', ') : '' }}
                      </div>
                    </div>
                  </template>
                <template v-else>
                  <div class="row align-items-center no-gutters mb-1">
                    <div class="col-lg-2">
                      <span class="text-muted">Not a designated person</span>
                    </div>
                  </div>
                </template>
                <template v-if="auditorData && auditorData.is_designated_person === 1">
                <div class="row align-items-center no-gutters my-3">
                  <div class="col-12">
                    <h6 class="mb-0 font-weight-bold e-text-red">DP Certificates</h6>
                  </div>
                </div>

                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-8">
                    <template v-if="!toEdit">
                      <div v-if="auditorData.certificates &&
                      auditorData.certificates.some(cert => cert.is_designated_person_certificate === 1)" class="row">
                        <div
                          v-for="certificate in auditorData.certificates.filter(cert => cert.is_designated_person_certificate === 1)"
                          :key="certificate.id" class="col-12 col-md-6 mb-3">
                          <div class="p-2 border rounded">
                            <div class="d-flex align-items-center">
                              <font-awesome-icon icon="file-pdf" size="2x" class="force-danger-all mr-2" @click.prevent="viewCertificate(certificate.path_url)"/>
                              <span class="font-weight-bold" :title="certificate.file_name">{{ truncateText(certificate.file_name, 30) }}</span>
                            </div>
                            <div class="mt-2 ml-4">
                              <strong>Issued Date:</strong> {{ certificate.issued_date ? certificate.issued_date : 'N/A' }}
                              <br>
                              <strong>Expiry Date:</strong> {{ certificate.expiration_date ? certificate.expiration_date : 'N/A' }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        No certificates found.
                      </div>
                    </template>

                    <template v-else>
                      <div class="mb-3 d-flex align-items-center">
                        <button type="button" class="btn btn-sm btn-success" @click="triggerFileUpload">
                          Add Attachments
                        </button>
                        <input type="file" multiple class="d-none" id="certificate-file-upload" ref="auditor_certificate" accept="application/pdf" @change="setAuditorCertificate">
                        <span
                          class="ml-2"
                          v-if="auditorEditedData.certificates &&
                          auditorEditedData.certificates.filter(cert => cert.is_designated_person_certificate === 1).length > 0"
                        >
                          {{ auditorEditedData.certificates.filter(cert => cert.is_designated_person_certificate === 1).length }}
                          {{ auditorEditedData.certificates.filter(cert => cert.is_designated_person_certificate === 1).length === 1 ? 'file' : 'files' }}
                        </span>
                      </div>
                      <div v-if="auditorEditedData.certificates &&
                      auditorEditedData.certificates.some(cert => cert.is_designated_person_certificate === 1)" class="row">
                        <div v-for="(certificate, index) in auditorEditedData.certificates.filter(cert => cert.is_designated_person_certificate === 1)" :key="certificate.id || certificate.file_name" class="col-12 col-md-6 mb-3">
                          <div class="p-2 border rounded position-relative">
                            <div class="d-flex align-items-center">
                              <p class="font-weight-bold">
                                <font-awesome-icon
                                  icon="file-pdf"
                                  size="2x"
                                  class="force-danger-all mr-2"
                                  @click.prevent="viewCertificate(certificate.path_url)"
                                /><span :title="certificate.file_name">{{ truncateText(certificate.file_name, 30) }}</span>
                              </p>
                            </div>
                            <button
                              type="button"
                              class="btn btn-sm btn-secondary position-absolute"
                              style="top: 0; right: 0; margin-top: 0px; margin-right: 0px;"
                              @click.prevent="removeCertificate(certificate)"
                            >
                              X
                            </button>
                            <div class="form-group row no-gutters mb-1">
                              <label :for="`issued_date-${index}`" class="font-weight-bolder col-sm-4 col-form-label">Issued Date</label>
                              <div class="col-sm-8">
                                <input type="date" :id="`issued_date-${index}`" class="form-control form-control-sm" v-model="certificate.issued_date">
                              </div>
                            </div>
                            <div class="form-group row no-gutters mb-1">
                              <label :for="`expiration_date-${index}`" class="font-weight-bolder col-sm-4 col-form-label">Expiry Date</label>
                              <div class="col-sm-8">
                                <input type="date" :id="`expiration_date-${index}`" class="form-control form-control-sm" v-model="certificate.expiration_date">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                </template>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppLoading from "@/components/elements/AppLoading";
import {mapActions, mapGetters} from "vuex";
import {AlertService} from "@/services/AlertService";
import {permissionMixin} from "@/mixins/permissionMixins";
import MultiSelectCustom from "@/components/MultiSelectCustom.vue";
import AuditorMixin from "@/mixins/AuditorMixin";
import DateMixin from "@/mixins/DateMixin";
import ImageCapture from "@/components/common/avatar/ImageCapture.vue";
import ImageUpload from "@/components/common/avatar/ImageUpload.vue";
// import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

export default {
  name: "AuditorDesignatedPersonCertificateInfo",
  mixins:[permissionMixin, DateMixin, AuditorMixin],
  data () {
    return {
      staffIcon: require('@/assets/staff_icon.png'),
      loading: false,
      auditorEditedData : null,
      toEdit: false,
      toImgUpload: false,
      toImgCapture: false,
      showCertificateField : false,
      certificatesToDelete : [],
      signatureImageSrc : null,
      croppedSignature : false
    }
  },

  methods: {
    ...mapActions(['getMngmtOfficeKeys', 'getAuditorData', 'getAuditorList', 'deleteAuditorCertificate', 'updateAuditor']),
    truncateText(text, length) {
      if (text.length > length) {
        return text.substring(0, length) + '...';
      }
      return text;
    },
    triggerFileUpload() {
      this.$refs.auditor_certificate.click();
    },
    // viewSignature() {
    //   const link = document.createElement('a');
    //   link.setAttribute('href', this.auditorData.signature_url);
    //   link.setAttribute('target', '_blank');
    //   document.body.appendChild(link);
    //   link.click();
    // },
    cancelEdit() {
      this.toEdit = false;
      this.auditorEditedData = Object.assign({}, this.auditorData);
      this.certificatesToDelete = [];
      this.croppedSignature = false;
      this.signatureImageSrc = null;
    },
    editAuditor() {
      this.auditorEditedData = Object.assign({}, this.auditorData);
      this.auditorEditedData.is_active = this.auditorData.is_active === 1 ? 1 : 0;
      this.auditorEditedData.certificates = Array.isArray(this.auditorData.certificates) ? this.auditorData.certificates.map(cert => ({...cert})) : [];
      this.toEdit = true;
    },
    async updateUser() {
      if (!this.toEdit) return;

      if (this.signatureImageSrc && this.croppedSignature === false) {
        return AlertService.errorAlert('Signature needs to be cropped before saving.', 'SAVING AUDITOR INFO');
      }

      let formData = new FormData();
      let param = Object.assign({}, this.auditorEditedData);

      if (param.email === '') {
        param.email = null;
      }
      if (param.contact_number === '') {
        param.contact_number = null;
      }

      formData.append('from_dp_certificate', 1);

      const newCertificates = param.certificates.filter(cert => cert.file);
      newCertificates.forEach((cert, index) => {
        formData.append(`certificate_files[${index}]`, cert.file);
        formData.append(`certificate_issued_dates[${index}]`, cert.issued_date || '');
        formData.append(`certificate_expiration_dates[${index}]`, cert.expiration_date || '');
        formData.append(`certificate_is_designated_person_certificate[${index}]`, 1);
      });

      const existingCertificates = param.certificates.filter(cert => cert.id && !cert.file);
      existingCertificates.forEach((cert, index) => {
        formData.append(`existing_certificate_ids[${index}]`, cert.id);
        formData.append(`existing_certificate_issued_dates[${index}]`, cert.issued_date || '');
        formData.append(`existing_certificate_expiration_dates[${index}]`, cert.expiration_date || '');

      });

      for (const key in param) {
        if (key !== 'certificates' && key !== 'profile_photo' && key !== 'is_internal_of_external_auditor' && key !== 'is_lead' && key !== 'email' && key !== 'contact_number' && key !== 'is_active') {
          formData.append(key, param[key] === null ? '' : param[key]);
        }
        if (key === 'audit_types' || key === 'lead_types') {
          param[key].forEach((item, item_key) => {
            formData.append(key + `[${item_key}]`, item);
          })
        }
      }

      formData.append('is_lead', param.is_lead ? 1 : 0);
      formData.append('is_internal_of_external_auditor', param.is_internal_of_external_auditor ? 1 : 0);
      formData.append('is_active', param.is_active ? 1 : 0);

      if (param.email !== null) {
        formData.append('email', param.email);
      }
      if (param.contact_number !== null) {
        formData.append('contact_number', param.contact_number);
      }

      for (const cert of this.certificatesToDelete) {
        await this.deleteAuditorCertificate(cert.id);
      }

      let updateResponse = await this.updateAuditor({
        id: this.auditorEditedData.id,
        formData: formData
      });

      if (updateResponse.result === false) {

        if (updateResponse.duplicate) {

          const proceed = await AlertService.confirmUpdateAlert(
            updateResponse.message + '\n Do you want to continue?',
            'Yes, Continue'
          );

          if (!proceed) {
            return;
          }

          formData.set('force_update', 1);

          updateResponse = await this.updateAuditor({
            id: this.auditorEditedData.id,
            formData: formData
          });

          if (updateResponse.result === false) {
            return AlertService.errorAlert(updateResponse.message, 'UPDATING OF AUDITOR');
          }

        } else {
          return AlertService.errorAlert(updateResponse.message, 'UPDATING OF AUDITOR');
        }
      }

      this.certificatesToDelete = [];

      await this.getAuditorData({
        auditor_id: this.$route.params.id
      });
      this.toEdit = false;
      this.signatureImageSrc = null;
      this.croppedSignature = false;
      AlertService.successAlert(updateResponse.message, 'UPDATING OF AUDITOR');
    },

    setSignature() {
      if (this.$refs.auditor_signature.files[0]) {
        const file = this.$refs.auditor_signature.files[0];
        if (file && file.type !== "image/png") {
          AlertService.errorAlert('Only PNG files are allowed.', 'IMAGE SIGNATURE SELECTION');
          this.signatureImageSrc = null;
          return;
        }

        this.signatureImageSrc = URL.createObjectURL(this.$refs.auditor_signature.files[0]);
      } else {
        this.signatureImageSrc = null;
      }
      this.croppedSignature = false;
    },
    cancelCropping() {
      this.signatureImageSrc = null;
      this.croppedSignature = false;
    },
    cropSignature() {
      const {canvas,} = this.$refs.cropper.getResult();
      this.signatureImageSrc = canvas.toDataURL();
      this.croppedSignature = true;

      canvas.toBlob((blob) => {
        this.auditorEditedData.signature = blob;
      }, 'image/png')
    },
    setAuditorCertificate() {
      const files = this.$refs.auditor_certificate.files;
      for (let i = 0; i < files.length; i++) {
        this.auditorEditedData.certificates.push({
          file: files[i],
          file_name: files[i].name,
          issued_date: null,
          expiration_date: null,
          is_designated_person_certificate: 1
        });
      }
    },
    removeSignature() {
      this.auditorEditedData.signature_url = null;
    },
    removeCertificate(certificate) {
      if (certificate.id) {
        this.certificatesToDelete.push(certificate);
      }

      const index = this.auditorEditedData.certificates.findIndex(
        cert => cert.id === certificate.id
      );

      if (index !== -1) {
        this.auditorEditedData.certificates.splice(index, 1);
      }
    },
    viewCertificate(url) {
      if (url) {
        window.open(url, '_blank');
      }
    },
    changeDesignatedPerson() {
      this.auditorEditedData.dp_branch_office_id = null;
      this.auditorEditedData.audit_types = [];
    },
    changeIsLead() {
      this.auditorEditedData.lead_types = [];
    }
  },

  components: {
    ImageUpload,
    ImageCapture,
    MultiSelectCustom,
    'loading': AppLoading,
    Cropper : () => import('vue-advanced-cropper')
  },
  computed: {
    ...mapGetters(['mngmntOfficeKeys', 'auditorData', 'leadAuditors', 'nonLeadAuditors']),
  },
  mounted() {
    $('#main_content').css({
      marginLeft: '15px',
      marginRight: '10px'
    });
  },
}
</script>

<style scoped lang="scss">
.nav > li {
  margin: .5rem 0;
  padding: .5rem;
  border-radius: 5px;

  &:hover, &:hover * {
    background-color: white;
    color: #d3313c;
  }
}

.e-btn-grp > li {
  list-style: none;
  font-size: 13px;
  padding: 4px;
  border-radius: 3px;
  color: #d3313c;
  cursor: pointer;

  &:hover {
    background-color: #fbeaec;
  }

  * {
    color: #d3313c;
  }
}

table tbody td {
  vertical-align: middle !important;
}

table tbody td label {
  margin-bottom: 0 !important;
}

#ModelNav {
  padding: 0;

  li > a {
    padding: .5rem 1rem;
    color: #435464;
  }

  li:hover a {
    border-bottom: 2px solid #d3313c;
    color: #d3313c;
  }
}

.router-link-active {
  border-bottom: 2px solid #d3313c;
  color: #d3313c;

  * {
    color: #d3313c;
  }
}
</style>
